import VConsole from 'vconsole';
let vLog = null;
// 初始化vConsole
const handleInitVConsole = function () {
  var _vLog;
  vLog = new VConsole();
  // // 按钮默认隐藏
  (_vLog = vLog) === null || _vLog === void 0 ? void 0 : _vLog.hideSwitch();
  handleShowVLolBtn();
};

// 连续点击左上角10次，才能显示调试按钮
const handleShowVLolBtn = function () {
  let count = 0;
  let clickTime = 0;
  document.body.addEventListener('click', function (event) {
    const diff = new Date().getTime() - clickTime;
    clickTime = new Date().getTime();
    //   每次点击触发时间小于500ms，并且点击的区域是左上角，则认为是连续点击
    if (diff > 500) {
      count = 0;
      return;
    }
    const {
      x,
      y
    } = event;
    if (x < 100 && y < 100) {
      count++;
    }
    if (count === 10) {
      var _vLog2;
      (_vLog2 = vLog) === null || _vLog2 === void 0 ? void 0 : _vLog2.showSwitch();
    }
  });
};
export { handleInitVConsole };